import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePagePermission, PagePermissionLevel, usePermissions } from '../hooks/usePermissions';

interface PermissionGuardProps {
  pageId: string;
  requiredLevel?: PagePermissionLevel;
  children: React.ReactNode;
}

export function PermissionGuard({
  pageId,
  requiredLevel = PagePermissionLevel.VIEW,
  children,
}: PermissionGuardProps) {
  const { hasPermission, loading, error } = usePagePermission(pageId, requiredLevel);

  // Show loading while permissions are being fetched
  if (loading) {
    return <div className="p-4">Loading permissions...</div>;
  }

  // If there was an error loading permissions, redirect to access denied
  if (error) {
    return <Navigate to="/admin/access-denied" replace />;
  }

  // Only redirect if we've confirmed the user doesn't have permission
  // (hasPermission is false when permissions are null, so this covers the no-permissions case)
  if (!hasPermission) {
    return <Navigate to="/admin/access-denied" replace />;
  }

  return <>{children}</>;
}
